import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BUTTONS, TEXT } from "@/utils/constants/appConstants/commonConstants";
import AppButton from "@/components/buttons/AppButton";

interface UserActivationModalProps {
    show?: boolean;
    onHide?: () => void;
    changeStatus: () => void;
    status?: boolean;
    loading?: boolean;
}

const UserActivationModal: React.FC<UserActivationModalProps> = (props) => {
    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="gs-confirm-dialog">
                <div className="gs-confirm-dialog__header">
                    <h4 className="gs-confirm-dialog__title" id="user-activate-title">
                        User Activation
                    </h4>
                </div>

                <div className="gs-confirm-dialog__body">
                    {props.status ? (
                        <p id="user-deactivate-message">{TEXT.DO_YOU_WANT_TO_DEACTIVATE_USER}</p>
                    ) : (
                        <p id="user-activate-message">{TEXT.DO_YOU_WANT_TO_ACTIVATE_USER}</p>
                    )}
                </div>

                <div className="gs-confirm-dialog__footer">
                    <AppButton
                        id="user-activate-confirm-btn"
                        onClick={props.changeStatus}
                        btnText={props.status ? BUTTONS.DEACTIVATE : BUTTONS.ACTIVATE}
                        isLoading={props.loading}
                        className={!props.status ? "btn-primary" : "btn-light"}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default UserActivationModal;
